/* VitaWoof PDP gallery (vw2). Compact contained main image + thumbnail strip, self-contained (no Horizon slideshow dependency). Thumb tap / swipe swaps the main image. The CSS zoom (jar photo has built-in whitespace) applies only to slide 1 — info slides carry edge text and must never be cropped, so show() toggles .vw2-nozoom for them. */
(function () {
  function init(root) {
    if (root.__vw2GalleryInit) return;
    root.__vw2GalleryInit = true;
    var main = root.querySelector('[data-vw2-gallery-main]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-vw2-thumb]'));
    if (!main || !thumbs.length) return;

    function show(thumb) {
      var src = thumb.getAttribute('data-src');
      if (src) main.src = src;
      var alt = thumb.getAttribute('data-alt');
      if (alt) main.alt = alt;
      main.classList.toggle('vw2-nozoom', thumbs.indexOf(thumb) !== 0);
      thumbs.forEach(function (t) {
        var on = t === thumb;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t); });
    });

    // Basic horizontal swipe on the main image.
    var x0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) < 40) return;
      var idx = thumbs.findIndex(function (t) { return t.classList.contains('is-on'); });
      if (idx < 0) idx = 0;
      var ni = dx < 0 ? Math.min(idx + 1, thumbs.length - 1) : Math.max(idx - 1, 0);
      if (ni !== idx) show(thumbs[ni]);
    }, { passive: true });
  }

  function boot() { document.querySelectorAll('[data-vw2-gallery]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
